<template>
  <div class="box">
    <iframe
      ref="childFrame"
      :src="childProjectUrl"
      @load="onIframeLoad"
      style="width: 100%; height: 100%; border: none"
    ></iframe>
    <div class="box-mask" v-if="!hideMask"></div>
  </div>
</template>

<script>
  const controlList=[
    {
      requestCode:"QYXD_CHW1",
      method:"updateEquipmentChiller",
      controlCode:"ZhiLengZhuJi_003",
      name: "1#冷水机组",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name:"主机冷冻水出口温度",value:'-',unit:"℃",code:"AI_T_EvaporatorWaterOUT"},
          { name: "主机运行时间", value: "-", unit: "H",code:"CR_RunningHours"},
          { name: "主机负载百分比", value: "-", unit: "%",code:"Avg_PhaseCurrent%" },
        ],
        core: { // 小弹框数据
          name: "温度",
          code:"AI_T_EvaporatorWaterOUT",
          value: "-"
        }
      }
    },{
      requestCode:"QYXD_CHW2",
      method:"updateEquipmentChiller",
      controlCode:"ZhiLengZhuJi_002",
      name: "2#冷水机组",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name:"主机冷冻水出口温度",value:'-',unit:"℃",code:"AI_T_EvaporatorWaterOUT"},
          { name: "主机运行时间", value: "-", unit: "H",code:"CR_RunningHours"},
          { name: "主机负载百分比", value: "-", unit: "%",code:"Avg_PhaseCurrent%" },
        ],
        core: { // 小弹框数据
          name: "温度",
          code:"AI_T_EvaporatorWaterOUT",
          value: "-"
        }
      }
    },{
      requestCode:"QYXD_CHW3",
      method:"updateEquipmentChiller",
      controlCode:"ZhiLengZhuJi_001",
      name: "3#冷水机组",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name:"主机冷冻水出口温度",value:'-',unit:"℃",code:"AI_T_EvaporatorWaterOUT"},
          { name: "主机运行时间", value: "-", unit: "H",code:"CR_RunningHours"},
          { name: "主机负载百分比", value: "-", unit: "%",code:"Avg_PhaseCurrent%" },
        ],
        core: { // 小弹框数据
          name: "温度",
          code:"AI_T_EvaporatorWaterOUT",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP2_1",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_001",
      name: "1#二次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP2_2",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_002",
      name: "2#二次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP2_3",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_003",
      name: "3#二次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP2_4",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_004",
      name: "4#二次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP1_1",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_005",
      name: "1#一次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP1_2",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_006",
      name: "2#一次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP1_3",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_007",
      name: "3#一次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CHP1_4",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_008",
      name: "4#一次泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CWP1",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_009",
      name: "1#冷却泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CWP2",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_010",
      name: "2#冷却泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CWP3",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_011",
      name: "3#冷却泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CWP4",
      method:"updateEquipmentWaterPump",
      controlCode:"beng_012",
      name: "4#冷却泵",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水泵运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水泵运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CT3",
      method:"updateEquipmentWaterTower",
      controlCode:"LengQueTA_001",
      name: "3#冷却塔",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水塔运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水塔运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CT2",
      method:"updateEquipmentWaterTower",
      controlCode:"LengQueTA_003",
      name: "2#冷却塔",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水塔运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水塔运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_CT1",
      method:"updateEquipmentWaterTower",
      controlCode:"LengQueTA_004",
      name: "1#冷却塔",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control",
        list:[
          { name: "水塔运行频率", value: "-", unit: "Hz",code:"Current_HZ"},
          { name: "水塔运行时间", value: "-", unit: "H",code:"RUNTIME"}
        ],
        core: { // 小弹框数据
          name: "频率",
          code:"Current_HZ",
          value: "-"
        }
      }
    },
    {
      requestCode:"QYXD_EVCHW3_1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_006",
      name: "V31",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW2_1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_007",
      name: "V21",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW1_1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_008",
      name: "V11",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW3_3",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_010",
      name: "V33",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW2_3",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_012",
      name: "V23",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW1_3",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_014",
      name: "V13",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW3_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_024",
      name: "V32",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW2_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_025",
      name: "V22",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHW1_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_026",
      name: "V12",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_1_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_016",
      name: "V15",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_2_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_018",
      name: "V25",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_3_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_020",
      name: "V35",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_4_2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_023",
      name: "V45",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_1_1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_017",
      name: "V14",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_2_1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_019",
      name: "V24",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCHP1_3_1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_021",
      name: "V34",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVBP",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_015",
      name: "旁通阀",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCT1",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_004",
      name: "V1",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCT2",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_003",
      name: "V2",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_EVCT3",
      method:"updateEquipmentElectricValve",
      controlCode:"DianDongFa_002",
      name: "V3",
      statusCode:"Status_Device",
      extData: {
        modeCode:"State_Control"
      }
    },
    {
      requestCode:"QYXD_CHP1_1",
      method:"controlPipeFlow",
      flowCodes:"JianTou_044,JianTou_045,JianTou_046,JianTou_068,JianTou_069,JianTou_070,JianTou_071,JianTou_072",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHP1_2",
      method:"controlPipeFlow",
      flowCodes:"JianTou_047,JianTou_048,JianTou_049,JianTou_063,JianTou_064,JianTou_065,JianTou_066,JianTou_067",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHP1_3",
      method:"controlPipeFlow",
      flowCodes:"JianTou_050,JianTou_051,JianTou_052,JianTou_057,JianTou_058,JianTou_059,JianTou_060,JianTou_061,JianTou_062",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHP1_4",
      method:"controlPipeFlow",
      flowCodes:"JianTou_053,JianTou_054,JianTou_055,JianTou_056",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHW3",
      method:"controlPipeFlow",
      flowCodes:"JianTou_159,JianTou_035,JianTou_036,JianTou_037,JianTou_038",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHW2",
      method:"controlPipeFlow",
      flowCodes:"JianTou_160,JianTou_073,JianTou_074,JianTou_075,JianTou_076",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHW1",
      method:"controlPipeFlow",
      flowCodes:"JianTou_161,JianTou_077,JianTou_078,JianTou_079,JianTou_080",
      code:"RUN"
    },
    {
      requestCode:"QYXD_EVBP",
      method:"controlPipeFlow",
      flowCodes:"JianTou_047",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHP2_1",
      method:"controlPipeFlow",
      flowCodes:"JianTou_006,JianTou_007",
      code:"Status_Device"
    },
    {
      requestCode:"QYXD_CHP2_2",
      method:"controlPipeFlow",
      flowCodes:"JianTou_008,JianTou_009",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHP2_3",
      method:"controlPipeFlow",
      flowCodes:"JianTou_010,JianTou_011",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CHP2_4",
      method:"controlPipeFlow",
      flowCodes:"JianTou_012,JianTou_013",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CWP1",
      method:"controlPipeFlow",
      flowCodes:"JianTou_119,JianTou_120,JianTou_121",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CWP2",
      method:"controlPipeFlow",
      flowCodes:"JianTou_122,JianTou_123,JianTou_124",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CWP3",
      method:"controlPipeFlow",
      flowCodes:"JianTou_125,JianTou_126,JianTou_127",
      code:"RUN"
    },
    {
      requestCode:"QYXD_CWP4",
      method:"controlPipeFlow",
      flowCodes:"JianTou_128,JianTou_129,JianTou_130",
      code:"RUN"
    },
    {
      requestCode:"QYXD_SYSSET",
      method:"controlPipeFlow",
      flowCodes:"JianTou_033,JianTou_034,JianTou_140,JianTou_141,JianTou_142,JianTou_143,JianTou_144,JianTou_145,JianTou_146,JianTou_147,JianTou_148,JianTou_149,JianTou_150,JianTou_151,JianTou_152,JianTou_153,JianTou_154,JianTou_155,JianTou_156,JianTou_157",
      code:"Run_CHPEV2"
    },
    {
      requestCode:"QYXD_SYSSET",
      method:"controlPipeFlow",
      flowCodes:"JianTou_039,JianTou_040,JianTou_041,JianTou_042,JianTou_043",
      code:"Run_CHPEV1"
    },
    {
      requestCode:"QYXD_SYSSET",
      method:"controlPipeFlow",
      flowCodes:"JianTou_158",
      code:"Run_CHWEV3"
    },
    {
      requestCode:"QYXD_SYSSET",
      method:"controlPipeFlow",
      flowCodes:"JianTou_003,JianTou_004",
      code:"Run_CHWEV2"
    },
    {
      requestCode:"QYXD_SYSSET",
      method:"controlPipeFlow",
      flowCodes:"JianTou_001,JianTou_002,JianTou_014,JianTou_015,JianTou_016,JianTou_017,JianTou_018,JianTou_019,JianTou_020,JianTou_021,JianTou_022,JianTou_023,JianTou_024,JianTou_025,JianTou_026,JianTou_027,JianTou_028,JianTou_029,JianTou_030,JianTou_031,JianTou_032",
      code:"Run_CHP2"
    },
    {
      requestCode:"QYXD_SYSSET",
      method:"controlPipeFlow",
      flowCodes:"JianTou_081,JianTou_082,JianTou_083,JianTou_084,JianTou_085,JianTou_086,JianTou_087,JianTou_088,JianTou_089,JianTou_090,JianTou_107,JianTou_108,JianTou_109,JianTou_110,JianTou_111,JianTou_112,JianTou_113,JianTou_114,JianTou_115,JianTou_116,JianTou_117,JianTou_118,JianTou_131,JianTou_132,JianTou_133,JianTou_134,JianTou_135,JianTou_136,JianTou_137,JianTou_138,JianTou_139,JianTou_162,JianTou_163,JianTou_164,JianTou_165,JianTou_166,JianTou_167,JianTou_168,JianTou_169,JianTou_170,JianTou_171,JianTou_172,JianTou_173",
      code:"Run_CWP"
    },
  ]

export default {
  data() {
    return {
      childProjectUrl: this.getChildProjectUrl(),
      childWindow: null,
      allCode:[],
      MqttClient:null
    }
  },
  props:{
    hideMask:{
      default:false,
    }
  },
  methods: {
     getChildProjectUrl() {
      return window.location.origin+"/screen-3d/index.html"
      // return "http://localhost:8889"
    },
    onIframeLoad() {
      this.childWindow = this.$refs.childFrame.contentWindow
      // 初始化通信
      this.initCommunication()
    },

    initCommunication() {
      // 监听来自子窗口的消息
      // console.log("监听来自子窗口的消息")
      window.addEventListener('message', this.handleMessageFromChild)
    },

    handleMessageFromChild(event) {
      // console.log("收到消息：",event)
      if(event.data.type=="CHILD_LOADED"){
        this.beReady = true
        // 3d设备地图已加载完成
        if(this.hideMask){
          // console.log(controlList)
          let i = 0
          for(let item of controlList){
            i++

            // console.log(i,controlList.length,this.allCode.length)
            if(!this.allCode.includes(item.requestCode)){
              this.allCode.push(item.requestCode)
              this.get('/Device/getPropertyValue', {
                deviceCode: item.requestCode
              }).then(res => {
                if (res.success) {
                  // 获取对应 code 的控件
                  var controls = controlList.filter(obj=>obj.requestCode==item.requestCode)
                  for(let control of controls){
                    var controlData = JSON.parse(JSON.stringify(control))
                    this.sendMessageToChild({
                      type:"update",
                      control:controlData,
                      result:res.result
                    })
                  }
                }
              })
            }
            if(i == controlList.length){
              // 开启mqtt
              this.openMqtt()
            }
          }
        }
      }else if (event.data.type=="CHILD_THINGEVENTS"){
        // console.log(event.data)
        this.$emit("changePanelBlock",event.data)
      }
    },

    sendMessageToChild(message) {
      if (!this.childWindow) return
      let msgUrl = window.location.origin
      // let msgUrl = "http://localhost:8889"
      this.childWindow.postMessage(message,msgUrl)
    },


    // mqtt方法
    openMqtt(){
      // console.log("open mqtt")
      var options ={
        clientId: this.$store.state.userData.code  + '_screen3D' + new Date().getTime(),
        connectTimeout: 600000,
        clean: true
      }
      this.MqttClient = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
      this.getMqttMessage()
    },
     /*接收mqtt*/
    getMqttMessage(){
      this.MqttClient.on('message', (topic, message) => {
        if(topic.indexOf('/property/push') != -1) {
          let data = JSON.parse(message.toString())
          // console.log(data)
          let controls = controlList.filter(item=>item.requestCode == data.deviceCode)
          if(controls.length){
            var result = []
            for(let key in data.items){
              result.push({code:key,value:data.items[key]})
            }
            for(let control of controls){
              var controlData = JSON.parse(JSON.stringify(control))
              this.sendMessageToChild({
                type:"update",
                control:controlData,
                result:result
              })
            }
          }
        }
      })
      // 订阅所有设备主题
      console.log("mqtt subscribe",JSON.parse(JSON.stringify(this.allCode)))
      for(let code of this.allCode){
        let url = `sys/device/${code}/property/push`
        // console.log(url)
        this.MqttClient.subscribe(url, { qos: 1 })
      }
    }
  },

  beforeDestroy() {
    // 移除事件监听
    this.allCode = []
    window.removeEventListener('message', this.handleMessageFromChild)
  }
}
</script>
<style scoped>
  .box{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .box-mask{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/screen-3d/screen-3d.vue